export default "__VITE_ASSET__Dr45BUHR__"